import React from "react"
import { Instagram, MessageCircle } from "lucide-react"

const paintings = [
  { id: 1, image: "/images/bull.jpeg", status: "AVAILABLE" },
  { id: 3, image: "/images/lizzard.jpeg", status: "SOLD" },
  { id: 7, image: "/images/2_cores.png", status: "AVAILABLE" },
  { id: 11, image: "/images/7_cores.png", status: "SOLD" },
  { id: 12, image: "/images/8_cores.png", status: "SOLD" },
  { id: 14, image: "/images/P2.jpeg", status: "AVAILABLE" },
  { id: 16, image: "/images/P4.jpeg", status: "AVAILABLE" },
  { id: 17, image: "/images/P5.jpeg", status: "AVAILABLE" },
  { id: 18, image: "/images/P7.jpeg", status: "AVAILABLE" },
]

export default function Painting() {
  const handleWhatsAppMessage = () => {
    const message = encodeURIComponent(
      `Hey Luís! I'm interested in purchasing some of your paintings. Could we talk about that, please?`
    )
    window.open(`https://wa.me/+351965220370?text=${message}`, "_blank")
  }

  const handleInstagramMessage = () => {
    const profileUrl =
      "https://www.instagram.com/luis_breatho/?igsh=MWJnZ2gwemhmZTQ4bQ=="
    window.open(profileUrl, "_blank")
  }

  return (
    <>
      <style jsx global>{`
        @font-face {
          font-family: "Muar-Regular";
          src: url("/fonts/Muar-Regular.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
        @font-face {
          font-family: "Muar-Stencil";
          src: url("/fonts/Muar-Stencil.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
      `}</style>
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        <h1 className="text-5xl mb-12 text-center text-purple-800 font-['Muar-Stencil']">
          Paintings and Drawings
        </h1>

        <p className="text-lg leading-relaxed text-gray-300 mb-6 font-['Muar-Regular']">
          A punk approach to painting and drawing is late, very late. "Punk" is
          anti-system, but how can one be anti- system when we live in times of
          everything, in times of totality and infinitude? Maybe these graphic
          expressions are a portrait of nothing, including beauty.{" "}
          <b>
            My attempt is to fail: portrait the lack of beauty that lies in
            beauty, and the beauty that lies in the lack of everything
          </b>
          . The hope is for people to feel welcome; including their nothingness
          and all that is too much. This is the concept of my concept, me
          pretending to pretend, never failing at failing, therefore, reminding
          us of what being human looks like. You can buy a piece, or order an
          original <b>here</b>.
        </p>

        <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4 mb-8">
          <button
            onClick={handleWhatsAppMessage}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-full flex items-center justify-center text-sm sm:text-base"
            aria-label="Send WhatsApp message"
          >
            <MessageCircle className="mr-2 h-5 w-5 sm:h-6 sm:w-6" />
            <span>Contact via WhatsApp</span>
          </button>
          <button
            onClick={handleInstagramMessage}
            className="bg-pink-500 hover:bg-pink-600 text-white font-bold py-2 px-4 rounded-full flex items-center justify-center text-sm sm:text-base"
            aria-label="Send Instagram message"
          >
            <Instagram className="mr-2 h-5 w-5 sm:h-6 sm:w-6" />
            <span>Follow on Instagram</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {paintings.map((painting) => (
            <div
              key={painting.id}
              className="bg-gray-100 rounded-lg shadow-lg overflow-hidden transform transition duration-300 hover:scale-105"
            >
              <div className="relative aspect-w-1 aspect-h-1 p-2">
                <div className="w-full h-full flex items-center justify-center">
                  <img
                    src={painting.image}
                    alt={`Painting ${painting.id}`}
                    className="max-w-full max-h-full object-contain rounded"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <span
                      className={`text-2xl font-bold ${
                        painting.status === "SOLD"
                          ? "text-red-500"
                          : "text-green-500"
                      }`}
                    >
                      {painting.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
